import {
    request,
    requestMedia
} from './request';
export default {
    login(data) {
        return request('api/login', data);
    }
}



// WEBPACK FOOTER //
// ./src/libs/axios/login.js